import { initialState } from "../store/initialState";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import { ReportDto } from "../types/report";

export default function volumeReportReducer(
  state: ReportDto = initialState.volumeReport,
  action: AnyAction
): ReportDto {
  switch (action.type) {
    case internalActionKeys.GET_VOLUME_REPORT_SUCCESS:
      return action.report;
    default:
      return state;
  }
}
